import React, { useEffect, useState } from "react";

import {
  Col,
  Row,
  Label,
  Button,
  //   Form,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  FormGroup,
} from "reactstrap";
import Select from "react-select";
import { Formik, Form } from "formik";
import * as Yup from "yup";

//Country-State-Cities
import csc from "countries-states-cities";

import { getCategoryTypeandParent } from "services/category.service";

const Step1 = ({ handleSubmitStepper, step1Values, parentCat, subCat }) => {
  const [countriesList, setCountriesList] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedParCat, setSelectedParCat] = useState(null);
  const [selectedSubCat, setSelectedSubCat] = useState(null);
  const [selectedPriceUnit, setSelectedPriceUnit] = useState(null);
  const [parentCategory, setParentCategory] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [subCatList, setSubCatList] = useState([]);
  let start = 20;
  let end = 150;
  let interval = 10;

  let minutesList = [];
  for (
    let currentMinute = start;
    currentMinute <= end;
    currentMinute += interval
  ) {
    // let hours = Math.floor(currentMinute / 60);
    // let minutes = currentMinute % 60;
    // let label = "";
    let SlotNumber = Math.ceil(currentMinute / 30);

    // if (hours > 0) {
    //   label = `${hours} hour${hours > 1 ? "s" : ""}`;
    //   if (minutes > 0) {
    //     label += ` ${minutes} Min`;
    //   }
    // } else {
    //   label = `${minutes} Min`;
    // }

    minutesList.push({
      label: currentMinute + " " + "Minutes",
      value: currentMinute,
      durationSlot: SlotNumber,
    });
  }

  const typeList = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    // { label: "Unisex", value: "Unisex" },
    { label: "Other", value: "Other" },
  ];

  const priceUnitList = [
    { label: "Hourly", value: "hourly" },
    { label: "Day", value: "Day" },
    { label: "Monthly", value: "monthly" },
  ];

  const initialValues = step1Values;
  console.log(initialValues, "initnvalues");
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please Enter Name"),
    categories: Yup.string().required("Please Select Sub Category"),
    parentCategory: Yup.string().required("Please Select Parent Category"),
    price: Yup.string().required("Please Enter Price"),
    discountPrice: Yup.string().required("Please Enter Discount Price"),
    // priceUnit: Yup.string().required("Please Enter Price Unit"),
    // customQuantityUnit: Yup.string().required(
    //   "Please Enter Custom Quantity Unit"
    // ),
    order: Yup.number().required("Please Enter Order"),
    duration: Yup.number().required("Please select Duration"),
    country: Yup.object().nullable().required("Please Select Country"),
    type: Yup.string().required("Please Select gender"),
  });

  useEffect(() => {
    let list = [];
    csc.getAllCountries().forEach(ele => {
      let obj = {
        value: ele.iso2,
        id: ele.id,
        label: ele.name,
      };
      list.push(obj);
    });
    setCountriesList(list);
  }, []);

  const getCategoryTypeParent = body => {
    getCategoryTypeandParent(body)
      .then(res => {
        const list = [];
        res?.data?.map(type => {
          list.push({ label: type.name, value: type._id });
        });
        setSubCatList(list);
      })
      .catch(err => {
        console.log(err);
      });
  };

  function handleSelectType(event) {
    setSelectedType(event);
    let list = [];
    parentCatList.forEach(ele => {
      if (ele.type == event.label) {
        list.push({
          label: ele.name,
          value: ele._id,
        });
      }
    });
    setParentCategory(list);
    setSubCatList([]);
    setSelectedParCat(null);
    setSelectedSubCat(null);
  }
  function handleSelectDuration(event) {
    console.log(event, "event");
    if (event) {
      setSelectedDuration(event);
    }
  }
  function handleSelectParentCat(event) {
    setSelectedParCat(event);
    if (selectedType?.value) {
      let obj = {
        type: selectedType.value,
        parentCategory: event.value,
      };
      getCategoryTypeParent(obj);
    }
    setSelectedSubCat(null);
  }
  function handleSelectSubCat(event) {
    setSelectedSubCat(event);
  }

  function handleSelectPriceUnit(event) {
    setSelectedPriceUnit(event);
  }

  const onSubmit = values => {
    let updatedValues = {
      ...values,
      durationSlot: selectedDuration?.durationSlot
        ? selectedDuration?.durationSlot
        : 1,
    };
    handleSubmitStepper(updatedValues);
  };
  return (
    <React.Fragment>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          handleChange,
          values,
        }) => {
          useEffect(() => {
            if (parentCat) {
              let obj = {
                value: parentCat._id,
                label: parentCat.name,
              };
              setParentCategory(obj);
              setSelectedParCat(obj);
              setFieldValue("parentCategory", parentCat._id);
              setFieldValue("type", parentCat.type);

              let typeObj = {
                value: parentCat.type,
                label: parentCat.type,
              };
              setSelectedType(typeObj);
            }
            if (subCat) {
              let obj = {
                value: subCat._id,
                label: subCat.name,
              };
              setSelectedSubCat(obj);
              setSubCatList([obj]);
              setFieldValue("categories", subCat._id);
              setFieldValue("duration", initialValues.duration);
            }
          }, [subCat]);
          return (
            <Form>
              <Row>
                <Col md={12}>
                  <Row>
                    <Col sm={4}>
                      <Label htmlFor="name" className=" col-form-label">
                        Name
                      </Label>

                      <Input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Enter Service Name"
                        name="name"
                        onChange={handleChange}
                        value={values.name}
                        invalid={touched.name && errors.name ? true : false}
                      />
                      {touched.name && errors.name ? (
                        <FormFeedback type="invalid">
                          {errors.name}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm={4} className="">
                      <Label htmlFor="country" className="col-form-label">
                        Country
                      </Label>
                      <Select
                        name="country"
                        id="country"
                        onChange={event => {
                          setFieldValue("country", event);
                        }}
                        options={countriesList}
                        value={values.country}
                        classNamePrefix="select2-selection"
                      />
                      {touched.country && errors.country && (
                        <Label className="statusValidation">
                          {errors.country}
                        </Label>
                      )}
                    </Col>

                    <Col sm={4}>
                      <Label htmlFor="order" className=" col-form-label">
                        Order
                      </Label>

                      <Input
                        type="text"
                        className="form-control"
                        id="order"
                        placeholder="Enter Order"
                        name="order"
                        onChange={handleChange}
                        value={values.order}
                        invalid={touched.order && errors.order ? true : false}
                      />
                      {touched.order && errors.order ? (
                        <FormFeedback type="invalid">
                          {errors.order}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm={4}>
                      <Label htmlFor="Gender" className="col-form-label">
                        Gender
                      </Label>

                      <Select
                        name="gender"
                        id="gender"
                        value={selectedType}
                        // onChange={event => {
                        //   handleSelectType(event);
                        //   handleChange("type")(event.value);
                        //   handleChange("parentCategory")("");
                        //   handleChange("categories")("");
                        // }}
                        isDisabled={true}
                        options={typeList}
                        classNamePrefix="select2-selection false__control--is-disabled"
                      />
                      {touched.type && errors.type && (
                        <Label className="statusValidation">
                          {errors.type}
                        </Label>
                      )}
                    </Col>

                    <Col sm={4}>
                      <Label
                        htmlFor="parentCategory"
                        className="col-form-label"
                      >
                        Parent Category
                      </Label>

                      <Select
                        name="parentCategory"
                        id="parentCategory"
                        value={selectedParCat}
                        // onChange={event => {
                        //   handleSelectParentCat(event);
                        //   handleChange("parentCategory")(event.value);
                        //   handleChange("categories")("");
                        // }}
                        isDisabled={true}
                        options={parentCategory}
                        classNamePrefix="select2-selection false__control--is-disabled"
                      />
                      {touched.parentCategory && errors.parentCategory && (
                        <Label className="statusValidation">
                          {errors.parentCategory}
                        </Label>
                      )}
                    </Col>

                    <Col sm={4}>
                      <Label htmlFor="subCategory" className="col-form-label">
                        Sub Category
                      </Label>

                      <Select
                        name="subCategory"
                        id="subCategory"
                        value={selectedSubCat}
                        // onChange={event => {
                        //   handleSelectSubCat(event);
                        //   handleChange("categories")(event.value);
                        // }}
                        isDisabled={true}
                        options={subCatList}
                        classNamePrefix="select2-selection false__control--is-disabled"
                      />
                      {touched.subCategory && errors.subCategory && (
                        <Label className="statusValidation">
                          {errors.subCategory}
                        </Label>
                      )}
                    </Col>

                    <Col md={4} className="">
                      <Label className="col-form-label">Price</Label>
                      <InputGroup>
                        <Input
                          name="price"
                          placeholder=""
                          type="number"
                          id="price"
                          value={values.price}
                          onChange={handleChange}
                          invalid={touched.price && errors.price ? true : false}
                        />
                        <InputGroupText>INR</InputGroupText>
                      </InputGroup>
                      {touched.price && errors.price ? (
                        <FormFeedback type="invalid">
                          {errors.price}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col md={4} className="">
                      <Label className="col-form-label">Discount Price</Label>
                      <InputGroup>
                        <Input
                          type="number"
                          placeholder=""
                          name="discountPrice"
                          value={values.discountPrice}
                          onChange={handleChange}
                          invalid={
                            touched.discountPrice && errors.discountPrice
                              ? true
                              : false
                          }
                          // disabled
                        />
                        <InputGroupText>INR</InputGroupText>
                      </InputGroup>
                      {touched.discountPrice && errors.discountPrice ? (
                        <FormFeedback type="invalid">
                          {errors.discountPrice}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col md={4} className="">
                      <Label htmlFor="price-Input" className="col-form-label">
                        Price Unit
                      </Label>
                      <Select
                        name="priceUnit"
                        value={selectedPriceUnit}
                        onChange={event => {
                          handleSelectPriceUnit(event);
                          handleChange("priceUnit")(event.value);
                        }}
                        options={priceUnitList}
                        classNamePrefix="select2-selection false__control--is-disabled"
                        isDisabled={true}
                      />
                      {touched.priceUnit && errors.priceUnit && (
                        <Label className="statusValidation">
                          {errors.priceUnit}
                        </Label>
                      )}
                    </Col>

                    <Col md={4} className="">
                      <Label
                        htmlFor="customQuantityUnit-Input"
                        className="col-form-label"
                      >
                        Custom quantity unit
                      </Label>
                      <Input
                        name="customQuantityUnit"
                        type="text"
                        className="form-control"
                        id="customQuantityUnit-Input"
                        onChange={handleChange}
                        value={values.customQuantityUnit}
                        invalid={
                          touched.customQuantityUnit &&
                          errors.customQuantityUnit
                            ? true
                            : false
                        }
                        disabled
                      />
                      {touched.customQuantityUnit &&
                      errors.customQuantityUnit ? (
                        <FormFeedback type="invalid">
                          {errors.customQuantityUnit}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col md={4} className="">
                      <Label
                        htmlFor="duration-Input"
                        className="col-form-label"
                      >
                        Duration
                      </Label>
                      <Select
                        name="duration"
                        id="duration-Input"
                        value={selectedDuration}
                        onChange={event => {
                          handleSelectDuration(event);
                          setFieldValue("duration", event.value);
                        }}
                        options={minutesList}
                        classNamePrefix="select2-selection"
                      />
                      {touched.duration && errors.duration ? (
                        <FormFeedback type="invalid">
                          {errors.duration}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <div className="d-flex mt-4 justify-content-end">
                <Button
                  color="primary"
                  className="w-md btn-sm ms-2"
                  type="submit"
                  // onClick={leaveToList}
                >
                  Next
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default Step1;
